@if (scenarioDifferenceMessage) {
  <div class="tw-relative tw-flex tw-h-full tw-flex-col tw-justify-between tw-w-full tw-p-7">
    <close-button class="tw-absolute tw-top-4 tw-right-4" [type]="'plain'"></close-button>
    <div class="tw-flex tw-flex-col tw-gap-6">
      <h1
        class="tw-font-montserrat tw-text-dt-text-headings tw-mb-5 tw-flex tw-items-center tw-justify-center tw-gap-1 tw-px-8 tw-text-4xl tw-font-bold xs:tw-px-6 xs:tw-text-3xl"
      >
        @if (scenarioDifferenceMessage.headerIcon === "institutions") {
          <app-account-icon-renderer
            [data]="scenarioDifferenceMessage.headerText"
            [useManageAccountStyle]="true"
          ></app-account-icon-renderer>
        } @else {
          <icon
            [name]="scenarioDifferenceMessage.headerIcon"
            [size]="invalidScenarioDiffMsg ? 10 : 8"
            [ngClass]="{
              'tw-stroke-white tw-bg-dt-custom-teal-9 tw-rounded-full tw-p-1':
                !invalidScenarioDiffMsg,
            }"
          ></icon>
        }
        {{ scenarioDifferenceMessage.headerText }}
      </h1>
      <div class="tw-flex tw-flex-col tw-px-36 tw-gap-6 xs:tw-px-0">
        @if (!invalidScenarioDiffMsg && scenarioDifferenceMessage.moreThanCurrent > 0) {
          <div>
            <span class="tw-text-2xl tw-font-medium">{{
              scenarioDifferenceConstant.willPayYou | i18n
            }}</span>
            <div class="tw-flex tw-justify-between">
              <div class="tw-text-dt-text-action tw-flex tw-flex-2">
                @if (scenarioDifferenceMessage.currentBalanceEarned !== 0) {
                  <app-number-roll-up-wrapper
                    class="tw-flex tw-items-center"
                    [componentID]="'number1'"
                    [currNum]="scenarioDifferenceMessage.moreThanCurrentPercent | macroNumber"
                    [fontSize]="firstRollNumSize"
                  >
                  </app-number-roll-up-wrapper>
                } @else {
                  <span class="tw-content-center tw-text-[5vh] xs:tw-text-[3vh]">{{
                    "infinity" | i18n
                  }}</span>
                }
                <span class="tw-content-center tw-pl-1 tw-text-[5vh] xs:tw-text-[3vh]">%</span>
              </div>
              <div class="tw-flex tw-justify-center tw-items-center">
                <div
                  class="tw-text-dt-text-contrast tw-bg-teal-700 tw-flex tw-rounded-3xl tw-px-3 tw-py-1"
                >
                  <span class="tw-content-center tw-text-[3vh] xs:tw-text-[2vh]">+$</span>
                  <app-number-roll-up-wrapper
                    class="tw-flex tw-items-center"
                    [componentID]="'number2'"
                    [currNum]="scenarioDifferenceMessage.moreThanCurrent | macroNumber"
                    [fontSize]="secondRollNumSize"
                  ></app-number-roll-up-wrapper>
                </div>
              </div>
            </div>
            <span class="tw-text-2xl tw-font-medium">{{
              scenarioDifferenceConstant.more | i18n
            }}</span>
            <p class="tw-my-0">{{ scenarioDifferenceConstant.over12Months | i18n }}</p>
          </div>
          <div>
            <p class="tw-text-dt-text-secondary">
              Just by using their
              <span class="tw-underline">{{
                scenarioDifferenceMessage.bestAccount.accountName
              }}</span>
            </p>
            <p class="tw-text-dt-text-secondary">
              To hold your
              <span class="tw-text-dt-text-headings"
                ><span class="tw-underline tw-decoration-primary">{{
                  currentBalance | currency: data.coreCurrency
                }}</span>
                {{ "balance" | i18n }}</span
              >
            </p>
          </div>
        } @else {
          <div class="tw-text-[20px]">
            <span class="tw-block">{{ scenarioDifferenceMessage.firstBlock.textOne }}</span>
            <span
              class="tw-block tw-text-2xl tw-font-bold"
              *ngIf="scenarioDifferenceMessage.firstBlock.numberToShow"
              >~
              {{
                scenarioDifferenceMessage.firstBlock.numberToShow
                  | currency: data.coreCurrency : "symbol"
              }}</span
            >
            <span class="tw-block">{{ scenarioDifferenceMessage.firstBlock.textTwo }}</span>
          </div>
          <div class="tw-text-[20px]">
            <span class="tw-block">{{ scenarioDifferenceMessage.secondBlock.textOne }}</span>
            <span
              class="tw-block tw-text-2xl tw-font-bold"
              *ngIf="scenarioDifferenceMessage.secondBlock.numberToShow"
              >{{
                scenarioDifferenceMessage.secondBlock.numberToShow
                  | currency: data.coreCurrency : "symbol"
              }}
              <svg class="tw-mr-3 tw-h-7 tw-w-7">
                <use xlink:href="images/sprite.svg#edit-icon" />
              </svg>
            </span>
            <span class="tw-block">{{ scenarioDifferenceMessage.secondBlock.textTwo }}</span>
          </div>
          <div class="tw-text-[20px]">
            @if (invalidScenarioDiffMsg) {
              <span
                class="tw-block tw-underline tw-text-orange-500 tw-cursor-pointer"
                (click)="this.openHelpBox()"
                >{{ scenarioDifferenceMessage.thirdBlock.textOne }}</span
              >
            }
            <span
              class="tw-block tw-text-2xl tw-font-bold"
              *ngIf="scenarioDifferenceMessage.thirdBlock.numberToShow"
              >{{
                scenarioDifferenceMessage.thirdBlock.numberToShow
                  | currency: data.coreCurrency : "symbol"
              }}
            </span>
            <span class="tw-block">{{ scenarioDifferenceMessage.thirdBlock.textTwo }}</span>
          </div>
        }
      </div>
    </div>
  </div>
  <div
    class="tw-mt-2.5 tw-flex tw-w-full tw-justify-end tw-gap-2 tw-py-6 tw-px-8 tw-bg-dt-surface-elevated tw-rounded-b-xl xs:tw-flex-col"
  >
    <div class="tw-w-1/2 xs:tw-w-full">
      <app-gloss-button
        class="tw-w-full"
        [options]="{
          text: scenarioDifferenceMessage.buttonText,
          type: 'submit',
          class: invalidScenarioDiffMsg ? 'neutral' : 'primary',
          onClick: closeDialogBtn.bind(this),
          isEnabled: true,
        }"
      ></app-gloss-button>
    </div>
  </div>
}
